exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-flex[data-v-00cd8488] {\n  flex-wrap: wrap;\n}\n.item[data-v-00cd8488] {\n  flex: 1 1;\n}\n.card[data-v-00cd8488] {\n  border-radius: 0;\n  flex-grow: 1;\n}\n#container[data-v-00cd8488] {\n  margin-bottom: -20px;\n}\n@media screen and (max-width: 991px) {\n#container[data-v-00cd8488] {\n    flex-direction: column;\n    align-items: center;\n}\n.card[data-v-00cd8488] {\n    width: 100%;\n}\n#group-details[data-v-00cd8488] {\n    flex-direction: column;\n    text-align: center;\n}\n.item[data-v-00cd8488]:not(:last-child) {\n    margin-bottom: 10px;\n}\n}\n", ""]);

// exports
